import { Article } from '../services/articleService';

export enum IssueStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived'
}

export interface Issue {
  id: number;
  title: string;
  description: string;
  volume: number;
  number: number;
  year: number;
  status: IssueStatus;
  downloads: number;
  coverImage?: string;
  topics: string[];
  articles: Article[];
  createdAt: string;
  updatedAt: string;
}

export interface IssueFormData {
  id?: number;
  title: string;
  description: string;
  volume: number;
  number: number;
  year: number;
  status: IssueStatus;
  coverImage?: string;
  topics: string[];
}

export interface IssueFilters {
  status?: IssueStatus;
  year?: number;
  volume?: number;
  search?: string;
} 